import { EndSessionWarningModalController } from '@app/components/modals/end-session-warning-modal/end-session-warning.modal-controller';
import { EndSessionWarningModalComponent } from '@app/components/modals/end-session-warning-modal/end-session-warning-modal.component';
import { EndSessionWarningModalService } from '@app/components/modals/end-session-warning-modal/end-session-warning.modal-service';
import { ModalLayoutModule } from '@app/components/modals/base/modal-layout/modal-layout.module';
import { ButtonsModule } from '@app/infrastructure/buttons/buttons.module';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [EndSessionWarningModalComponent],
	exports: [EndSessionWarningModalComponent],
	imports: [ModalLayoutModule, ButtonsModule],
	providers: [EndSessionWarningModalController, EndSessionWarningModalService],
})
export class EndSessionWarningModalModule {}
